<form name="form" class="form-horizontal" #pdfForm="ngForm" (ngSubmit)="submit()">
    <div class="modal-header d-flex align-items-start">
        <div class="mr-auto">
            <h3 class="modal-title">{{title}}</h3>
        </div>
        <div class="ml-2">
            <mon-icon class="text-grey" [icon]="['ACTIONS', 'CLOSE']" (click)="cancel('cancelled')"></mon-icon>
        </div>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label for="tokens" class="col-sm-8 col-form-label">
                {{ (isSubtract ? 'Tokens to subtract' : 'Tokens to add') | translate }}
            </label>
            <div class="col-sm-40">
                <input
                    type="number"
                    class="form-control"
                    id="tokens"
                    [name]="'tokens'"
                    [placeholder]="'Enter positive number' | translate"
                    [(ngModel)]="tokens"
                    min="0"
                    [required]="true"
                    #tokensInput="ngModel"
                />
                <div *ngIf="tokensInput.invalid && (tokensInput.dirty || tokensInput.touched)" class="text-danger">
                    <small *ngIf="tokensInput.errors?.['required']">{{ 'This field is required' | translate }}</small>
                    <small *ngIf="tokensInput.errors?.['min']">{{ 'Please enter a positive number' | translate }}</small>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-default"
            (click)="cancel('cancelled')"
            translate
        >
            Cancel
        </button>
        <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!pdfForm.form.valid"
            translate
        >
            Submit
        </button>
    </div>
</form>
